import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import logo_pop from '../assets/images/logo-pop.png';
import ProfileHeader from '../components/ProfileHeader';
import { useSelector } from 'react-redux';
import EDSFooter from '../components/EDSFooter';

const Potwierdzenie_zakupu_powturne = () => {
    const history = useHistory();
    let time = [];

    const coursesHeadings = JSON.parse(localStorage.getItem('coursesHeadings'));
    const dataStart = JSON.parse(localStorage.getItem('dateToBay'));
    const [res, setRes] = useState(time);
    const messege = useSelector((state) => state.repos.messege);

    return (
        <>
            
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>
                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>
            <div className="content">
                <ProfileHeader></ProfileHeader>
                <main className="responsive-padding margin-top-64">
                    <h2 className="h2">Status: {messege? messege: ''} </h2>
                     
                    
                   
                    <div>
                                               
                        <p id="purchased-title" className="purchased__title h3 margin-top-32">
                            {coursesHeadings.courseHeadingName}, {(coursesHeadings.courseLevel)? coursesHeadings.courseLevel + ',': ''}{' '}
                            {(coursesHeadings.courseDanceStyle)? 'styl: ' + coursesHeadings.courseDanceStyle: ''}
                        </p>
                        <p className="text-large margin-top-8">
                           {(coursesHeadings.statusMessege)? '': 'Dziękujemy!'} 
                            </p>
                        <p className="text-large margin-top-32">
                            Do zobaczenia na najbliższych zajęciach!
                        </p>
                        {(coursesHeadings.statusMessege)? '':  
                        <p id="purchased-date">{'Start kursu: ' + ((new Date(coursesHeadings.startingDate) > new Date(dataStart))? coursesHeadings.startingDate: dataStart)}</p>}
                        {/* <p id="purchased-time">
                            {'Zajęcia w dniach: ' }{' '}
                            <ul id="related-list"> 
                                {res.map((el) => (
                                    <p>{el.name}</p>
                                ))}
                            </ul>

                        </p> */}
                        <p className="margin-top-32">
                        </p>
                    </div>
                    <div>
                        <Link to="/taniec_kurs">
                            <a
                                href=""
                                className="btn-secondary-responsive btn-secondary-responsive--medium margin-top-32"
                            >
                                Zapisz się na kolejny kurs
                            </a>
                        </Link>
                    </div>
                    <div className="margin-top-32">
                        <Link to="/taniec">
                            <a
                                href=""
                                className="btn-secondary-responsive btn-secondary-responsive--medium"
                            >
                                Wróć do strony głównej
                            </a>
                        </Link>
                    </div>
                </main>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Potwierdzenie_zakupu_powturne;
